import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_URL } from "../../constants/contact";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function Contatto() {
  const [form, setForm] = useState({ nominativo: "", telefono: "", attivita: "" });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (sending) return;
    setSending(true);
    try {
      await axios.post(`${API}/leads`, form);
      setSent(true);
      setForm({ nominativo: "", telefono: "", attivita: "" });
      toast.success("Dati inviati. Alberto ti ricontatta personalmente a breve.");
    } catch (err) {
      toast.error("Invio non riuscito. Riprova o scrivi direttamente su WhatsApp.");
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="contatto" data-testid="contatto-section" className="py-24 bg-[#1B4D3E] text-[#F6F5F2] px-6">
      <div className="max-w-3xl mx-auto text-center">
        <span className="font-sans text-xs uppercase tracking-widest text-[#A3B18A] font-bold">Linea Diretta</span>
        <h2 className="text-3xl md:text-5xl font-normal mt-2 mb-4">Invia l'estratto conto ad Alberto.</h2>
        <p className="font-sans text-sm text-[#D1E7DD] mb-10 max-w-lg mx-auto">
          Riceverai un riscontro chiaro con il confronto dei costi effettivi e la proposta idonea per la tua attività.
        </p>

        <div className="bg-white text-[#1C1B1A] p-8 md:p-10 font-sans text-left border border-[#D1E7DD]">
          {sent ? (
            <div data-testid="form-success-message" className="text-center py-8">
              <p className="font-editorial text-2xl text-[#1B4D3E] mb-2">Richiesta ricevuta.</p>
              <p className="text-sm text-[#5A564F] mb-6">
                Ti ricontatto personalmente per la prima lettura dei costi. Se preferisci, scrivimi subito su WhatsApp.
              </p>
              <button
                type="button"
                data-testid="form-send-another-button"
                onClick={() => setSent(false)}
                className="text-xs font-bold uppercase tracking-widest text-[#1B4D3E] underline underline-offset-4"
              >
                Invia un'altra richiesta
              </button>
            </div>
          ) : (
            <form data-testid="contact-form" className="space-y-4" onSubmit={onSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-xs font-bold uppercase text-[#5A564F]">
                <div>
                  <label htmlFor="nominativo" className="block mb-1">Nominativo</label>
                  <input
                    id="nominativo"
                    name="nominativo"
                    type="text"
                    required
                    value={form.nominativo}
                    onChange={onChange}
                    data-testid="form-input-nominativo"
                    className="w-full p-3 border border-[#D1E7DD] font-normal text-sm focus:outline-none focus:border-[#1B4D3E]"
                    placeholder="Nome e Cognome"
                  />
                </div>
                <div>
                  <label htmlFor="telefono" className="block mb-1">Recapito Telefonico</label>
                  <input
                    id="telefono"
                    name="telefono"
                    type="tel"
                    required
                    value={form.telefono}
                    onChange={onChange}
                    data-testid="form-input-telefono"
                    className="w-full p-3 border border-[#D1E7DD] font-normal text-sm focus:outline-none focus:border-[#1B4D3E]"
                    placeholder="324 0000000"
                  />
                </div>
              </div>
              <div className="text-xs font-bold uppercase text-[#5A564F]">
                <label htmlFor="attivita" className="block mb-1">Denominazione / Settore</label>
                <input
                  id="attivita"
                  name="attivita"
                  type="text"
                  value={form.attivita}
                  onChange={onChange}
                  data-testid="form-input-attivita"
                  className="w-full p-3 border border-[#D1E7DD] font-normal text-sm focus:outline-none focus:border-[#1B4D3E]"
                  placeholder="Nome attività o categoria"
                />
              </div>
              <button
                type="submit"
                disabled={sending}
                data-testid="form-submit-button"
                className="w-full py-4 bg-[#1B4D3E] text-white font-bold text-xs uppercase tracking-widest hover:bg-[#12352B] transition-colors disabled:opacity-60"
              >
                {sending ? "Invio in corso..." : "Invia Dati per Diagnosi Gratuita"}
              </button>
            </form>
          )}

          <div className="mt-8 pt-6 border-t border-[#E3DFD7] flex flex-col sm:flex-row justify-between items-center gap-4 text-xs">
            <span className="font-bold text-[#1B4D3E]">Oppure contatta direttamente:</span>
            <div className="flex gap-3">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-whatsapp-button"
                className="px-4 py-2 bg-[#25D366] text-white font-bold tracking-wider hover:bg-[#20ba5a] transition-colors"
              >
                WhatsApp {PHONE_DISPLAY}
              </a>
              <a
                href={PHONE_TEL}
                data-testid="contact-call-button"
                className="px-4 py-2 bg-[#1B4D3E] text-white font-bold tracking-wider hover:bg-[#12352B] transition-colors"
              >
                Chiama {PHONE_DISPLAY}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
